var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.envData.page_type === 'digital-twin')?_c('div',[_c('digital-twin')],1):_vm._e(),(_vm.envData.page_type === 'future')?_c('div',[_c('future')],1):_vm._e(),(_vm.envData.page_type === 'ylyx')?_c('div',[_c('ylyx')],1):_vm._e(),(_vm.envData.page_type === 'cdc')?_c('div',[_c('cdc')],1):_c('div',[_vm._v("请配置环境变量page_type")])])
}
var staticRenderFns = []

export { render, staticRenderFns }